import ApiEndpoint, { ApiResponse } from 'network/ApiEndpoint'
import { mapEventResponse } from './mapEventResponse'

export const getEventGamesFromDates = async ({
  channelSlug,
  eventSlug,
  selectedDate,
  currentPage,
  perPage
}: {
  channelSlug: string
  eventSlug: string
  selectedDate: string
  currentPage: number
  perPage: number
}) => {
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: `events/event/${eventSlug}/dates/${selectedDate}`,
      params: {
        company: channelSlug,
        page: currentPage,
        per_page: perPage
      }
    })
    const responseData = await resultResponse
    const map = mapEventResponse(responseData.data, false)
    return { data: map, totalCount: responseData.totalCount! }
  } catch (e: any) {
    // @ts-ignore
    throw new Error(e.message)
  }
}
